import React, { useEffect, useRef, useState } from 'react';
import {
    Table,
    Container, Row, Col,
    Alert,
    Card, CardBody, CardTitle, FormGroup, Spinner, Form, Input, Button, Modal
} from "reactstrap";
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
// import img from './executivePage.jpeg'

const ExecutiveSummaryPDFPage = () => {
    const [openCrop, setOpenCrop] = useState(false)
    const [image_url, setImage_Url] = useState(null)

    const handleChange = e => {
        const file = e.target.files[0]
        if (file) {
            var u = URL.createObjectURL(file)
            var img = new Image()
            img.onload = function () {
                var IMAGE_HEIGHT = img.height
                var IMAGE_WIDTH = img.width

                setHeightWidth({
                    myheight: IMAGE_HEIGHT,
                    mywidth: IMAGE_WIDTH,
                })
            }
            img.src = u
            setFile(file)
            setImage_Url(u)
            setOpenCrop(true)
        }
        console.log(file)
    }

    return(
        <>
           <div>
               <MetaTags>
                   <title>Mambo - Report</title>
               </MetaTags>
               <Container fluid={true} style={{
                transform: "scale(.8) translate(-130px, -132px) ",
                width: "1400px",
                }}>
               <Row>
                    <Col md="8">
                        <div style={{
                            width: "816px",
                            height: "1056px",
                            // border: "1px solid grey",
                            boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, .1)",
                            position: "relative",
                        }}>
                            <Row className='g-0'>
                                <Col md="5">
                                    <div style={{
                                        height: '1056px',
                                        width: "100%",
                                        background: !openCrop && image_url && "url(" + image_url + ")",
                                        backgroundColor: "#f0f0f0",
                                        backgroundRepeat: "no-repeat",
                                        backgroundPosition: "center",
                                        backgroundSize: "cover",
                                    }}>

                                    </div>
                                </Col>
                                <Col md="7">

                                </Col>
                            </Row>
                        </div>
                    </Col>
                </Row>
               </Container>
           </div>
        </>
    );
}

export default ExecutiveSummaryPDFPage;